import { useNavigate } from 'react-router-dom';
import Navbar from '../../components/Navbar/Navbar';
import './AccessDenied.css';

function IconShieldX() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="72"
      height="72"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.4"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
      <line x1="9" y1="9" x2="15" y2="15" />
      <line x1="15" y1="9" x2="9" y2="15" />
    </svg>
  );
}

function IconArrowLeft() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <line x1="19" y1="12" x2="5" y2="12" />
      <polyline points="12 19 5 12 12 5" />
    </svg>
  );
}

function AccessDenied() {
  const navigate = useNavigate();

  return (
    <div className="ad-page">
      <Navbar />
      <main className="ad-main">
        <div className="ad-card">
          {/* Icon */}
          <div className="ad-icon-wrap">
            <IconShieldX />
          </div>

          {/* Heading */}
          <h1 className="ad-heading">¡Acceso Denegado! <span className="ad-frown">:(</span></h1>

          {/* Primary message */}
          <p className="ad-message">
            Lo sentimos, parece ser que no tienes acceso a esta vista debido a tu rol de usuario en el portal.
          </p>

          {/* Divider */}
          <div className="ad-divider" aria-hidden="true" />

          {/* Secondary message */}
          <p className="ad-contact">
            Si crees que se cometió un error, puedes contactar al administrador del portal.
          </p>

          {/* CTA */}
          <button className="ad-btn" onClick={() => navigate('/dashboard')}>
            <IconArrowLeft />
            Regresar a Tablero
          </button>
        </div>
      </main>
    </div>
  );
}

export default AccessDenied;
